/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BillingCodeSearchResponse } from '../models/BillingCodeSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BillingCodesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search for TARDOC billing codes.
     *
     * When query is empty, returns all codes with pagination.
     * When query is provided, searches across code number, title, and description.
     * @returns BillingCodeSearchResponse
     * @throws ApiError
     */
    public billingCodesSearch({
        query,
        skip,
        top = 100,
    }: {
        /**
         * Search query for billing codes. Searches across code, title, and description.
         */
        query?: string,
        /**
         * Number of results to skip for pagination.
         */
        skip?: number,
        /**
         * Maximum number of results to return (max 100).
         */
        top?: number,
    }): CancelablePromise<BillingCodeSearchResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/billing-codes/search/',
            query: {
                'query': query,
                'skip': skip,
                'top': top,
            },
        });
    }
}
